/**
 * A mixin to allow any component to log and event or error
 */
import { mapActions } from 'vuex'
// import Vue from 'vue'

export default {
  name: 'Logger',
  methods: Object.assign({}, mapActions('logger', [ 'logError', 'logInfo', 'logWarning' ]))
}
